import { create } from 'zustand';

import { PREVIEW_BAR_VIEW_TYPE } from '~/constants/common';
import { PreviewBarViewType } from '~/types/builder';

type SidebarState = {
  isMobilePreviewOpened: boolean;
  setIsMobilePreviewOpened: (isOpen: boolean) => void;
  activeStep: number;
  setActiveStep: (step: number) => void;
  previewViewType: PreviewBarViewType;
  setPreviewViewType: (type: PreviewBarViewType) => void;
  selectQrTypeHovered: string;
  setSelectQrTypeHovered: (selectQrTypeHovered: string) => void;
};

const useBuilderStore = create<SidebarState>((set) => ({
  isMobilePreviewOpened: false,
  setIsMobilePreviewOpened: (isOpen) => set({ isMobilePreviewOpened: isOpen }),
  activeStep: 0,
  setActiveStep: (step) => set({ activeStep: step }),
  previewViewType: PREVIEW_BAR_VIEW_TYPE.PHONE,
  setPreviewViewType: (type) => set({ previewViewType: type }),
  selectQrTypeHovered: '',
  setSelectQrTypeHovered: (selectQrTypeHovered) => {
    set({ selectQrTypeHovered });
  },
}));

export default useBuilderStore;
